<template>
    <div class="payments-quantity">
        <input v-if="disableQuantity" type="hidden" name="quantity" :value="defaultQuantity"  />
        <span v-if="!disableQuantity">Qty.</span>
        <input v-if="!disableQuantity"
            type="number"
            :min="min"
            :value="defaultQuantity"
            name="quantity"
            class="form-control"
            v-on:input="$emit('input', $event.target.value)"
            v-on:blur="$emit('filled-out',$event.target.value)"
            v-on:change="$emit('filled-out',$event.target.value)"
        />
    </div>
</template>

<script>
  export default {
    props: {
        min: 0,
        defaultQuantity: {},
        disableQuantity: 0,
    },
    data() {
        return {
            quantityModel: {}
        }
    },
    created() {
        if (!this.quantityModel && this.defaultQuantity) {
            this.quantityModel = this.defaultQuantity;
        }
    },
  };
</script>
